// extracted by mini-css-extract-plugin
export var phone = "_5l-0";